export interface Category {
  id: string;
  name: string;
  url: string;
  icon: string;
  description: string;
}

export const categories: Category[] = [
  {
    id: 'shoes',
    name: 'Shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    icon: 'ri-footprint-line',
    description: 'Najlepsze sneakersy i buty – Nike, Jordan, Adidas, New Balance i więcej',
  },
  {
    id: 'hoodies',
    name: 'Hoodies/Sweaters',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    icon: 'ri-t-shirt-line',
    description: 'Bluzy z kapturem, swetry – streetwear i casual',
  },
  {
    id: 'tshirts',
    name: 'T-Shirts',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    icon: 'ri-shirt-line',
    description: 'Koszulki – basic, premium i limitowane edycje',
  },
  {
    id: 'jackets',
    name: 'Jackets',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    icon: 'ri-shirt-line',
    description: 'Kurtki, płaszcze – na każdą porę roku',
  },
  {
    id: 'pants',
    name: 'Pants/Shorts',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    icon: 'ri-check-double-line',
    description: 'Spodnie, szorty, jeansy – od streetwear po elegancję',
  },
  {
    id: 'headwear',
    name: 'Headwear',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    icon: 'ri-sun-line',
    description: 'Czapki, kapelusze i akcesoria na głowę',
  },
  {
    id: 'sets',
    name: 'Sets',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    icon: 'ri-stack-line',
    description: 'Komplety ubrań – dopasowane zestawy',
  },
  {
    id: 'underwear',
    name: 'Underwear/Underpants',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    icon: 'ri-checkbox-blank-line',
    description: 'Bielizna i bokserki w najlepszych cenach',
  },
  {
    id: 'jersey',
    name: 'Jersey',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    icon: 'ri-t-shirt-line',
    description: 'Koszulki sportowe i piłkarskie trykoty',
  },
  {
    id: 'accessories',
    name: 'Accessories',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    icon: 'ri-glasses-line',
    description: 'Okulary, biżuteria, zegarki i dodatki',
  },
  {
    id: 'bags',
    name: 'Bags',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    icon: 'ri-shopping-bag-line',
    description: 'Torby, plecaki, nerki – styl i funkcjonalność',
  },
  {
    id: 'belts',
    name: 'Belts',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    icon: 'ri-link',
    description: 'Paski – skórzane, sportowe i designerskie',
  },
  {
    id: 'perfumes',
    name: 'Perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    icon: 'ri-drop-line',
    description: 'Perfumy i wody toaletowe w świetnych cenach',
  },
  {
    id: 'other',
    name: 'Other Stuff',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    icon: 'ri-more-line',
    description: 'Wszystko inne – elektronika, gadżety i więcej',
  },
];

export const mainSiteUrl = 'https://kaspreadsheet.com';

export const faqData = [
  {
    question: 'Czym jest Kakobuy Spreadsheet?',
    answer: 'Kakobuy Spreadsheet to uporządkowana baza produktów w formie arkusza kalkulacyjnego, która zawiera setki sprawdzonych linków, kategorii, cen i informacji o produktach dostępnych przez Kakobuy. To narzędzie, które pomaga użytkownikom szybko znaleźć najlepsze oferty z chińskich platform zakupowych bez konieczności samodzielnego przeszukiwania tysięcy aukcji.',
  },
  {
    question: 'Jak korzystać z Kakobuy Spreadsheet?',
    answer: 'Korzystanie z arkusza jest proste – wystarczy otworzyć spreadsheet, wybrać interesującą kategorię (np. buty, bluzy, akcesoria) i kliknąć w link do produktu. Każdy wpis zawiera zdjęcie, cenę orientacyjną, nazwę produktu oraz bezpośredni link do zakupu przez Kakobuy. Arkusz jest regularnie aktualizowany o nowe znaleziska.',
  },
  {
    question: 'Czy Kakobuy Spreadsheet jest darmowy?',
    answer: 'Tak, dostęp do Kakobuy Spreadsheet jest całkowicie darmowy. Twórcy arkusza udostępniają go społeczności bez żadnych opłat. Możesz przeglądać wszystkie kategorie, linki i informacje bezpłatnie. Jedynym kosztem jest zakup samych produktów oraz opłaty za wysyłkę przez Kakobuy.',
  },
  {
    question: 'Czy Kakobuy jest bezpieczny dla kupujących z Polski?',
    answer: 'Kakobuy to legalna platforma pośrednicząca w zakupach z Chin. Oferuje ochronę kupujących, możliwość wykonania zdjęć QC (kontroli jakości) przed wysyłką, ubezpieczenie przesyłek oraz wsparcie w przypadku problemów. Dla kupujących z Polski dostępnych jest kilka opcji wysyłki, w tym linie tax-free, które minimalizują ryzyko dodatkowych opłat celnych.',
  },
  {
    question: 'Jakie produkty znajdę w Kakobuy Spreadsheet?',
    answer: 'W arkuszu znajdziesz tysiące produktów w kategoriach: sneakersy (Nike, Jordan, Adidas, Yeezy), odzież (bluzy, koszulki, kurtki, spodnie), akcesoria (czapki, paski, torby, okulary), elektronikę, perfumy i wiele więcej. Arkusz obejmuje zarówno produkty popularne, jak i ukryte perełki – tzw. finds, które trudno znaleźć samodzielnie.',
  },
  {
    question: 'Jak często aktualizowany jest Kakobuy Spreadsheet?',
    answer: 'Arkusz jest aktualizowany regularnie – zazwyczaj co kilka dni lub co tydzień. Nowe produkty są dodawane, a niedostępne usuwane. Dzięki temu zawsze masz dostęp do aktualnych ofert i działających linków. Najlepsze znaleziska są oznaczane, abyś mógł szybko znaleźć produkty o najlepszym stosunku jakości do ceny.',
  },
  {
    question: 'Jak znaleźć najlepsze Kakobuy finds?',
    answer: 'Najlepsze finds znajdziesz w dedykowanych sekcjach arkusza oznaczonych jako "Hot Finds" lub "Best Sellers". Dodatkowo społeczność Kakobuy na Reddit i Discord regularnie dzieli się nowymi odkryciami. Warto też śledzić kanały YouTube i TikTok poświęcone Kakobuy, gdzie influencerzy testują i recenzują produkty z arkusza.',
  },
  {
    question: 'Czy mogę zamawiać produkty prosto z arkusza do Polski?',
    answer: 'Tak, wszystkie produkty z arkusza można zamówić z dostawą do Polski. Kakobuy oferuje różne metody wysyłki – od ekonomicznych po ekspresowe. Dla polskich kupujących polecane są linie DHL Tax-Free lub Europe Tariffless, które zapewniają bezproblemową dostawę bez dodatkowych opłat celnych. Czas dostawy wynosi zazwyczaj 10-20 dni.',
  },
  {
    question: 'Co to są zdjęcia QC i dlaczego są ważne?',
    answer: 'Zdjęcia QC (Quality Check) to fotografie wykonane przez pracowników magazynu Kakobuy po otrzymaniu Twojego zamówienia, ale przed wysyłką do Polski. Pozwalają one sprawdzić stan produktu, zgodność z opisem, ewentualne wady czy uszkodzenia. Jeśli produkt nie spełnia oczekiwań, możesz poprosić o zwrot do sprzedawcy lub wymianę – wszystko przed zapłaceniem za międzynarodową wysyłkę.',
  },
  {
    question: 'Ile kosztuje wysyłka Kakobuy do Polski?',
    answer: 'Koszt wysyłki zależy od wagi paczki, wybranej metody dostawy oraz wymiarów produktów. Przykładowo, para butów to koszt około 150-250 PLN za wysyłkę linią tax-free. Bluza czy koszulka to około 80-150 PLN. Kakobuy oferuje kalkulator wysyłki, który pozwala oszacować koszty przed złożeniem zamówienia. Warto łączyć kilka produktów w jedną paczkę, aby obniżyć koszt wysyłki na sztukę.',
  },
  {
    question: 'Czy Kakobuy Spreadsheet zawiera produkty podrobione?',
    answer: 'Arkusz zawiera linki do produktów dostępnych na chińskich platformach – niektóre z nich mogą być replikami lub inspirowanymi markowymi produktami. Kakobuy Spreadsheet nie promuje podrabiania, ale pomaga użytkownikom znaleźć produkty o wysokiej jakości w przystępnych cenach. Każdy użytkownik samodzielnie decyduje, które produkty chce zamówić.',
  },
  {
    question: 'Jakie są alternatywy dla Kakobuy?',
    answer: 'Główne alternatywy to Sugargoo, Pandabuy (obecnie niedostępny w wielu krajach), CSSBuy, Wegobuy oraz bezpośrednie zakupy na Taobao, 1688 czy Weidian. Kakobuy wyróżnia się przyjaznym interfejsem, konkurencyjnymi cenami wysyłki i dostępnością dla polskich użytkowników. Kakobuy Spreadsheet jest kompatybilny również z tymi platformami – linki zazwyczaj działają uniwersalnie.',
  },
  {
    question: 'Jak rozpocząć korzystanie z Kakobuy po raz pierwszy?',
    answer: 'Aby zacząć: (1) Załóż darmowe konto na Kakobuy, (2) Otwórz Kakobuy Spreadsheet i wybierz interesujące Cię produkty, (3) Wklej link do produktu w wyszukiwarce Kakobuy, (4) Dodaj produkt do koszyka i opłać zamówienie, (5) Poczekaj na dostawę do magazynu Kakobuy, (6) Sprawdź zdjęcia QC, (7) Wybierz metodę wysyłki do Polski i opłać przesyłkę, (8) Odbierz paczkę!',
  },
  {
    question: 'Czy mogę zwrócić produkt kupiony przez Kakobuy?',
    answer: 'Tak, Kakobuy oferuje możliwość zwrotu produktów, które nie spełniają oczekiwań lub są wadliwe. Zwroty są obsługiwane na etapie magazynu w Chinach (przed wysyłką międzynarodową). Po otrzymaniu zdjęć QC możesz zgłosić chęć zwrotu, a Kakobuy zajmie się procesem. Po wysyłce do Polski zwroty są trudniejsze i droższe, dlatego zdjęcia QC są tak ważne.',
  },
  {
    question: 'Gdzie mogę znaleźć społeczność Kakobuy Polska?',
    answer: 'Polska społeczność Kakobuy jest aktywna na Reddit (r/FashionRepsPolska, r/FashionReps), Discordzie oraz grupach na Facebooku. Tam użytkownicy dzielą się znaleziskami, recenzjami, zdjęciami QC i poradami dotyczącymi wysyłki do Polski. Kakobuy Polska Wiki również regularnie publikuje nowe poradniki i artykuły, aby pomóc polskim użytkownikom w bezpiecznych zakupach.',
  },
];